import { useQuery } from "react-query";

const useBPADetailsPage = (tenantId, filters, config) => {
  // if (["form11", "form26", "formCLU", "formNOC", "formMT", "form16"].includes(config?.formType)) {
  //   return useQuery(["BPA_DETAILS_PAGE", filters, tenantId], () => Digit.OBPSService.BPADetailsPageForm11(tenantId, filters), config);
  // }
  if (["MAP_SUB", "NOC"].includes(config?.formType)) {
    return useQuery(["BPA_DETAILS_PAGE", filters, tenantId], () => Digit.OBPSService.BPASearch(tenantId, filters), config?.config);
  }
  if (["formLandUse", "FORM_PRESSRELEASE", "oldCaseSearchLU"].includes(config?.formType)) {
    return useQuery(["BPA_DETAILS_PAGE", filters, tenantId], () => Digit.OBPSService.BPASearchFormLandUse(tenantId, filters), config);
  }
  if (["OWNER_REGISTRATION"].includes(config?.formType)) {
    return useQuery(["BPA_DETAILS_PAGE", filters, tenantId], () => Digit.OBPSService.BPAOwnerRegistration(tenantId, filters), config);
  }
  if (["PURCHASABLE_FAR"].includes(config?.formType)) {
    return useQuery(["BPA_DETAILS_PAGE", filters, tenantId], () => Digit.OBPSService.BPASearchPurchasableFAR(tenantId, filters), config);
  }
  return useQuery(["BPA_DETAILS_PAGE", filters, tenantId], () => Digit.OBPSService.BPADetailsPage(tenantId, filters), config);
};

export default useBPADetailsPage;
